import { defineMessages, FormattedMessage } from '@faceup/localization'
import { Typography } from '@faceup/ui-base'

const messages = defineMessages('followUp.pages.page.components.pageNotFound', [
  { id: 'title', defaultMessage: '' },
  { id: 'description', defaultMessage: '' },
] as const)

const PageNotFound = () => (
  <>
    <Typography.Title className='text-center'>
      <FormattedMessage message={messages.title} />
    </Typography.Title>
    <Typography.Text className='text-center'>
      <FormattedMessage message={messages.description} />
    </Typography.Text>
  </>
)

export default PageNotFound
